import { AddOrUpdateInterestedFormData } from "./config";
import { ProfileDataWithTopics, TopicItem } from "./types";

export function mapSelectedToFormValues(
  selected: TopicItem | null
): AddOrUpdateInterestedFormData {
  if (!selected) {
    return { label: "", priority: "" };
  }
  return {
    label: selected.label ?? "",
    priority: selected.priority ?? "",
  };
}

export function getTopicsPayload(
  formData: AddOrUpdateInterestedFormData,
  existingTopics: TopicItem[],
  selectedIntrested: TopicItem | null
): { topics: TopicItem[] } {
  const topics = Array.isArray(existingTopics) ? [...existingTopics] : [];
  const newItem: TopicItem = {
    label: formData.label || "",
    priority: formData.priority ?? "",
  };

  if (selectedIntrested) {
    const idx = topics.findIndex(
      (t) => t?.label === selectedIntrested?.label
    );
    if (idx >= 0) {
      const next = [...topics];
      next[idx] = newItem;
      return { topics: next };
    }
  }
  return { topics: [...topics, newItem] };
}
